import React, { useRef, useState } from "react";
import classes from "./Header.module.css";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Tooltip,
  Stack,
  Divider,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Drawer,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Close, KeyboardArrowRight, MenuOpen } from "@mui/icons-material";
import { Link } from "react-scroll";
import DropDownButton from "../HomeButtons/DropDownButton";
import { NavLink, useNavigate } from "react-router-dom";
import SignupModal from "../SignupModal/SignupModal";
import Dbutton from "../../Dashboard/DashboardButtons/Dbutton";
import Logo from "../../../assets/images/svg/Logo.svg";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const steps = [{ label: "Email" }, { label: "OTP" }, { label: "Success" }];

const NavLinks = () => {
  const [open, setOpen] = useState(false);

  const [selectedRole, setSelectedRole] = useState("");

  const [demomodal, setDemoModal] = useState(false);
  const [step, setStep] = useState(1); // 1: Email, 2: OTP, 3: Success
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);

  const otpRefs = [useRef(), useRef(), useRef(), useRef()];
  const [selectedDemo, setSelectedDemo] = useState(null); // "signup" or "merchant"

  const [anchorEl, setAnchorEl] = useState(null);
  const opened = Boolean(anchorEl);

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (demoType) => {
    setSelectedDemo(demoType);
    setStep(1);
    setDemoModal(true);
    handleClose();
  };

  const handleRoleChange = (role) => {
    setSelectedRole(role);
  };
  const [openSignupOptions, setOpenSignupOptions] = useState(false);
  const handleCloseSignupOptions = () => {
    setOpenSignupOptions(false);
    setSelectedRole("");
  };
  const navigate = useNavigate();

  const loginOptions = [
    {
      path: "login",
      path_name: "Buyer login",
    },
    {
      path: "login",
      path_name: "Vendor login",
    },
  ];
  const signupOptions = [
    {
      path: "buyer_organization_signup",
      path_name: "Buyer Organization Signup",
    },
    {
      path: "vendor_signup",
      path_name: "Vendor Signup",
    },
  ];
  const linkActiveStyles = {
    color: "#3D4BD6",
    borderBottom: "2px solid #3D4BD6",
  };

  const openDemoModal = () => {
    setDemoModal(true);
    setStep(1);
  };

  const selectDemoType = (demoType) => {
    setSelectedDemo(demoType);
    setStep(1);
  };

  const redirectVendorPage = () => {
    setStep(1);
    setEmail("");
    setDemoModal(false);

    if (selectedDemo === "signup") {
      navigate("/poc_vendor_signup");
    } else if (selectedDemo === "invoice") {
      navigate("/poc_Invoice_Automation");
    }
  };

  const sendOTP = async () => {
    setIsLoading(true);
    try {
      const res = await axios.post(API_ENDPOINT.send_otp_to_email, { email });
      console.log(res.data.message);
      setStep(2);
    } catch (err) {
      console.error(err.response?.data?.error || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOTP = async () => {
    // if (otp.join("") === "1234") setStep(3);
    const enteredOTP = otp.join("");

    if (enteredOTP.length < 4) {
      alert("Please enter a 4-digit OTP");
      return;
    }

    try {
      const response = await axios.post(API_ENDPOINT.verify_otp, {
        email: email,
        otp: enteredOTP,
      });

      if (response.data.message === "OTP verified") {
        setStep(3);
      } else {
        alert("OTP verification failed");
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "OTP verification failed");
    }
  };

  const handleOtpChange = (index, value) => {
    const updated = [...otp];
    updated[index] = value.slice(-1); // only take last digit
    setOtp(updated);

    if (value && index < otp.length - 1) {
      otpRefs[index + 1].current.focus(); // move to next box
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs[index - 1].current.focus();
    }
  };

  return (
    <div>
      <div className={`${classes.links} ${classes.flex}`}>
        <li>
          <Link
            onClick={() => navigate("/")}
            spy={true}
            activeStyle={linkActiveStyles}
            to="heroContent"
            duration={500}
            offset={-120}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            onClick={() => navigate("/")}
            spy={true}
            activeStyle={linkActiveStyles}
            to="features"
            duration={500}
            offset={-120}
          >
            Features
          </Link>
        </li>

        <li>
          <Link
            onClick={() => navigate("/")}
            spy={true}
            activeClass={classes.active_link}
            activeStyle={linkActiveStyles}
            to="contact_us"
            duration={500}
            offset={-100}
          >
            Contact Us
          </Link>
        </li>
        <DropDownButton
          label={"Signup"}
          noOptions={true}
          mainClick={() => {
            setOpenSignupOptions(true);
          }}
        />
        <DropDownButton
          label={"Login"}
          noOptions={true}
          mainClick={() => navigate("/login")}
        />

        <Dbutton
          label="POC"
          onClick={handleClick}
          endIcon={<ArrowDropDownIcon />}
          style={{ display: "flex", alignItems: "center", gap: 4 }}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: 2,
              minWidth: 200,
              boxShadow: "0 16px 40px rgba(31,45,58,0.1)",
              py: 0.5,
              marginLeft:"-45px",
              fontFamily:"sans-serif",
              fontSize:"1.5rem"

             
            },
          }}
        >
          <MenuItem
            onClick={() => handleSelect("signup")}
            sx={{
              py: 1.5,
              px: 2.5,
              fontSize: "1.25rem",
              fontWeight: 600,
              borderRadius: 1,
              transition: "background .2s",
              "&:hover": {
                backgroundColor: "rgba(63,81,181,0.08)",
              },
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 0.5,
             
            }}
          >
            <span>Vendor Onboarding Automation</span>
          
          </MenuItem>

          <MenuItem
            onClick={() => handleSelect("invoice")}
            sx={{
              py: 1.5,
              px: 2.5,
              fontSize: "1.25rem",
              fontWeight: 600,
              borderRadius: 1,
              transition: "background .2s",
              "&:hover": {
                backgroundColor: "rgba(63,81,181,0.08)",
              },
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 0.5,
            }}
          >
            <span>Merchant Invoice Automation</span>
            
          </MenuItem>
        </Menu>
      </div>

      <button onClick={() => setOpen(true)} className={classes.menuOpener}>
        <MenuOpen className={classes.menuOpenerIcon} />{" "}
      </button>

      <Drawer open={open} anchor={"right"} className={classes.menuDraw}>
        <div className={classes.menuTab}>
          <div className={`${classes.MenuLinks} ${classes.flex}`}>
            <li>
              <Link
                onClick={() => navigate("/")}
                spy={true}
                to="heroContent"
                duration={500}
                offset={-120}
                activeStyle={linkActiveStyles}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="features"
                spy={true}
                onClick={() => navigate("/")}
                duration={500}
                offset={-120}
                activeStyle={linkActiveStyles}
              >
                Features
              </Link>
            </li>
            {/* <li><Link to="about_us">About Us</Link></li> */}
            <li>
              <Link
                to="contact_us"
                onClick={() => navigate("/")}
                spy={true}
                duration={500}
                offset={-100}
                activeStyle={linkActiveStyles}
              >
                Contact Us
              </Link>
            </li>
          </div>
          <div className={classes.lgBtn}>
            <DropDownButton
              label={"Signup"}
              noOptions={true}
              mainClick={() => {
                setOpenSignupOptions(true);
              }}
            />
            <DropDownButton
              label={"Login"}
              noOptions={true}
              mainClick={() => navigate("/login")}
            />
          </div>
        </div>
        <button onClick={() => setOpen(false)} className={classes.closeButton}>
          <Close className={classes.closeButtonIcon} />
        </button>
      </Drawer>

      <SignupModal
        openSignupOptions={openSignupOptions}
        selectedRole={selectedRole}
        handleCloseSignupOptions={handleCloseSignupOptions}
        setOpenSignupOptions={setOpenSignupOptions}
        handleRoleChange={handleRoleChange}
      />

      {/* <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                          <Box sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              width: 600,
                              bgcolor: 'background.paper',
                              boxShadow: 24,
                              p: 4,
                              borderRadius: 2
                          }}></Box> */}

      <Modal open={demomodal} onClose={() => setDemoModal(false)} keepMounted>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: { xs: "90%", sm: 500 },
            maxWidth: 600,
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 3,
            borderRadius: 3,
            p: { xs: 3, sm: 5 },
            outline: "none",
          }}
        >
          {/* Close button */}
          <IconButton
            onClick={() => setDemoModal(false)}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              bgcolor: "rgba(0,0,0,0.04)",
              "&:hover": { bgcolor: "rgba(0,0,0,0.08)" },
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          {/* Header with logo */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
            sx={{ mb: 2 }}
          >
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.4rem", sm: "1.5rem" },
                  fontWeight: 700,
                  letterSpacing: 0.5,
                }}
              >
                Explore POC
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: "text.secondary", mt: 0.5, fontSize: "1.2rem" }}
              >
                Real flow, real data, zero fluff.
              </Typography>
            </Box>
            <Box component="img" src={Logo} alt="logo" sx={{ width: 90 }} />
          </Stack>

          <Divider sx={{ mb: 3 }} />

       

          {/* Content */}
          {/* {step === 0 && (
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  fontSize: { xs: "1.6rem", sm: "1.8rem" },
                  textAlign: "center",
                }}
              >
                Choose a POC
              </Typography>

              <Stack spacing={2}>
                <Tooltip
                  title={
                    <Box
                      sx={{
                        maxWidth: 380,
                        backgroundColor: "#fff",
                        color: "#1f2937",
                        fontSize: "15px",
                        p: 2,
                        borderRadius: 2,
                        boxShadow: 4,
                        lineHeight: 1.5,
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: 700, fontSize: "16px", mb: 1 }}
                      >
                        Experience BIDz.ai in Action - No Simulations, Only
                        Real Results.
                      </Typography>
                      <Typography sx={{ mb: 1 }}>
                        Our POC environment lets you complete the entire vendor
                        onboarding process exactly as it works in
                        production-from entering a PAN number and fetching live
                        KYC data directly from government portals to uploading
                        documents and seeing them instantly cross-verified.
                        Within minutes, you’ll see how our platform autonomously
                        approves onboarding when data matches, all without any
                        manual effort.
                      </Typography>
                      <Typography sx={{ mb: 1 }}>
                        We’ve kept it controlled and secure by limiting the POC
                        to three vendor onboardings, but you get the full,
                        real-time experience of our automation-no dummy data, no
                        half-built screens, just the actual product doing what
                        it does best - simplifying onboarding and ensuring
                        compliance at lightning speed.
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="right"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        p: 0,
                        backgroundColor: "transparent",
                        boxShadow: "none",
                      },
                    },
                  }}
                > 
                  <Box
                    onClick={() => selectDemoType("signup")}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      border: "1px solid",
                      borderColor: "divider",
                      backgroundColor: "background.default",
                      cursor: "pointer",
                      transition: "all .2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      "&:hover": {
                        boxShadow: 3,
                        borderColor: "primary.main",
                        backgroundColor: "rgba(59, 77, 214, 0.05)",
                      },
                    }}
                  >
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, fontSize: "1.3rem" }}
                      >
                        VendorOnboarding Automation
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "text.secondary",
                          mt: 0.5,
                          fontSize: "1rem",
                        }}
                      >
                        Real onboarding flow
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        ml: 1,
                        fontSize: "1.25rem",
                      }}
                    >
                      →
                    </Typography>
                  </Box>
                 </Tooltip> 

                <Box
                  onClick={() => selectDemoType("invoice")}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor: "background.default",
                    cursor: "pointer",
                    transition: "all .2s",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    "&:hover": {
                      boxShadow: 3,
                      borderColor: "primary.main",
                      backgroundColor: "rgba(59, 77, 214, 0.05)",
                    },
                  }}
                >
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, fontSize: "1.3rem" }}
                    >
                      Merchant Invoice Automation
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        mt: 0.5,
                        fontSize: "1rem",
                      }}
                    >
                      Bulk invoice flow
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", ml: 1, fontSize: "1.25rem" }}
                  >
                    →
                  </Typography>
                </Box>
              </Stack>
            </Box>
          )} */}

          {step === 1 && (
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "13px", color: "text.secondary" }}
              >
             
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, mt: 1, mb: 1 }}>
                Enter your Business Email Address
              </Typography>
             
              <TextField
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="poc@bidz.ai"
                variant="outlined"
                size="small"
                sx={{ mb: 2, "& .MuiInputBase-input": { fontSize: "1.2rem" } }}
              />
              <Button
                fullWidth
                variant="contained"
                disabled={!email || isLoading}
                onClick={sendOTP}
                sx={{
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 700,
                  boxShadow: 2,
                  fontSize: "1.25rem",
                }}
              >
                {isLoading ? "Sending OTP..." : "Next"}
              </Button>
            </Box>
          )}

          {step === 2 && (
            <Box>
            
              <Typography variant="h5" sx={{ fontWeight: 700, mt: 1, mb: 1 }}>
                Enter one-time password
              </Typography>
              <Typography variant="body1" sx={{ mb: 1, fontSize: "1.2rem" }}>
                A one-time password has been sent to <b>{email}</b>
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, fontSize: "1.2rem" }}>
                Enter the 4 digit code we sent via email to continue.
              </Typography>
              <Box
                display="flex"
                justifyContent="center"
                gap={1}
                mb={2}
                flexWrap="wrap"
              >
                {otp.map((digit, i) => (
                  <TextField
                    size="small"
                    key={i}
                    inputRef={otpRefs[i]}
                    value={digit}
                    onChange={(e) => handleOtpChange(i, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: "center", fontSize: "1.5rem" },
                    }}
                    sx={{ width: 70 }}
                  />
                ))}
              </Box>
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 2,
                  color: "text.secondary",
                  fontSize: "1.075rem",
                }}
              >
                Not your email? Didn’t receive the code?{" "}
                <Box
                  component="span"
                  onClick={() => setStep(1)}
                  sx={{
                    color: "primary.main",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: 600,
                  }}
                >
                  Try Again
                </Box>
              </Typography>
              <Button
                fullWidth
                variant="contained"
                onClick={verifyOTP}
                sx={{
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 700,
                  display: "flex",
                  justifyContent: "justify-center",
                  boxShadow: 2,
                  fontSize: "1.25rem",
                }}
              >
                <span>Next</span>
                {/* <KeyboardArrowRight /> */}
              </Button>
            </Box>
          )}

          {step === 3 && (
            <Box textAlign="center">
              <CheckCircleOutlineIcon
                sx={{ fontSize: 70, color: "success.main", mb: 1 }}
              />
              <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                Welcome to POC Page
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, fontSize: "1.2rem" }}>
                Your OTP Verification has been completed successfully!
              </Typography>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  redirectVendorPage();
                }}
                sx={{
                  mt: 1.5,
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 700,
                  boxShadow: 2,
                  fontSize: "1.25rem",
                }}
              >
                Close
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default NavLinks;
